// function loadMarkdownEnFiles() {
//     const context = require.context('/public/en/docs', true, /\.md$/); // 加载 markdown 文件夹下的所有 .md 文件
//     const files = context.keys().map((key) => ({
//       path: key.replace(/^\./, ''), // 移除开头的点号
//       name: key.split('/').pop().replace('.md', ''), // 提取文件名
//     }));
//     console.log('Loaded files:', files); // 添加日志查看可用文件
//     return files;
// }


//写死顺序
function loadMarkdownJaFiles() {
    return [
      {
        path: '/集中機能について.md',
        name: '集中機能について'
      },
      {
        path: '/モニタリング機能について.md',
        name: 'モニタリング機能について'
      },
      {
        path: '/統計機能について.md',
        name: '統計機能について'
      },
      {
        path: '/GenR会員規約.md',
        name: 'GenR会員規約'
      },
      {
        path: '/GenRプライバシーポリシー.md',
        name: 'GenRプライバシーポリシー'
      },
      {
        path: '/GenR利用規約.md',
        name: 'GenR利用規約'
      }
    ]
}

export default loadMarkdownJaFiles;
